import { toast } from "sonner";
import { api, formatApiErrorDetail } from "@/lib/api";

export async function startCheckout(lookupKey, user, navigate) {
  if (user === null) {
    toast.info("One moment — loading your account…");
    return;
  }
  if (!user) {
    toast.info("Log in or create a free account first", { description: "Your purchase is linked to your account." });
    navigate(`/login?next=${encodeURIComponent(window.location.pathname)}`);
    return;
  }
  try {
    const { data } = await api.post("/payments/checkout", { lookup_key: lookupKey, origin_url: window.location.origin });
    if (data.checkout_url) window.location.href = data.checkout_url;
  } catch (err) {
    toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Could not start checkout");
  }
}

export async function downloadEbook() {
  try {
    const res = await api.get("/ebook/download", { responseType: "blob" });
    const url = URL.createObjectURL(res.data);
    const a = document.createElement("a");
    a.href = url;
    a.download = "Sportsbook-Smasher-Football-Edition.pdf";
    a.click();
    URL.revokeObjectURL(url);
  } catch (err) {
    let msg = "Download failed";
    try { msg = JSON.parse(await err.response.data.text()).detail || msg; } catch { /* noop */ }
    toast.error(msg);
  }
}

export const PLAN_LOOKUP = { starter: "starter_monthly", pro: "pro_monthly" };
export const EBOOK_LOOKUP = "ebook_football";
